/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MoneyTypeCardIcon16Light } from './MoneyTypeCardIcon16Light';
import { MoneyTypeCardIcon16Regular } from './MoneyTypeCardIcon16Regular';
import { MoneyTypeCardIcon16Solid } from './MoneyTypeCardIcon16Solid';
import { MoneyTypeCardIcon20Light } from './MoneyTypeCardIcon20Light';
import { MoneyTypeCardIcon20Regular } from './MoneyTypeCardIcon20Regular';
import { MoneyTypeCardIcon20Solid } from './MoneyTypeCardIcon20Solid';
import { MoneyTypeCardIcon24Regular } from './MoneyTypeCardIcon24Regular';
import { MoneyTypeCardIcon24Solid } from './MoneyTypeCardIcon24Solid';
import { MoneyTypeCardIcon32Regular } from './MoneyTypeCardIcon32Regular';
import { MoneyTypeCardIcon64Regular } from './MoneyTypeCardIcon64Regular';
var sizes = {
    16: {
        light: MoneyTypeCardIcon16Light,
        regular: MoneyTypeCardIcon16Regular,
        solid: MoneyTypeCardIcon16Solid,
    },
    20: {
        light: MoneyTypeCardIcon20Light,
        regular: MoneyTypeCardIcon20Regular,
        solid: MoneyTypeCardIcon20Solid,
    },
    24: {
        regular: MoneyTypeCardIcon24Regular,
        solid: MoneyTypeCardIcon24Solid,
    },
    32: {
        regular: MoneyTypeCardIcon32Regular,
    },
    64: {
        regular: MoneyTypeCardIcon64Regular,
    },
};
export var MoneyTypeCardIcon = forwardRef('MoneyTypeCardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
